import { SVGProps } from 'react';

import palette from '../../../theme/palette';
import { styleConfigs } from '../../resources/styleConfigs';

const MessageQuestionIcon = ({
  width = styleConfigs.dimensions.width24,
  height = styleConfigs.dimensions.height24,
  stroke = palette.light.icons.mistBlue,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.75 18.75H11.25L5.25 23.25V18.75H2.25C1.42157 18.75 0.75 18.0784 0.75 17.25V2.25C0.75 1.42157 1.42157 0.75 2.25 0.75H21.75C22.5784 0.75 23.25 1.42157 23.25 2.25V17.25C23.25 18.0784 22.5784 18.75 21.75 18.75Z"
      stroke={stroke}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 6.75011C9.00029 5.22454 10.1455 3.94212 11.6613 3.76987C13.1771 3.59762 14.5808 4.59039 14.9234 6.077C15.266 7.5636 14.4383 9.07059 13 9.57911C12.4004 9.7911 11.9997 10.3581 12 10.9941V11.2501"
      stroke={stroke}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 14.25C11.7929 14.25 11.625 14.4179 11.625 14.625C11.625 14.8321 11.7929 15 12 15C12.2071 15 12.375 14.8321 12.375 14.625C12.375 14.4179 12.2071 14.25 12 14.25V14.25"
      stroke={stroke}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MessageQuestionIcon;
